import client from '../base-api';

const serviceURL = '/time-management';

export const timeManagementService = {

    getDataForMonth(year: string, month: string, userId?: number) {   
        return client.get(`${serviceURL}/data-for-month/${year}/${month}/${userId ? userId : ''}`);
    },
    getTotalForMonth(year: string, month: string, userId?: number) {  
        return client.get(`${serviceURL}/total-for-month/${year}/${month}/${userId ? userId : ''}`);
    },
    postSave(formData: any) {  
        return client.post(`${serviceURL}/save`, formData);
    },
    informHr(year: string, month: string) {
        return client.put(`${serviceURL}/inform_hr/${year}/${month}`);
    },
    delete(id: number) {  
        return client.delete(`${serviceURL}/delete/${id}`);
    },
    getOverview(year: number, userId: number) {  
        return client.get(`${serviceURL}/overview/${year}/${userId}`);
    },
    getMonthlyOverviewHr(filterData:any ) {  
        return client.get(`${serviceURL}/monthly-overview-hr`, {params: filterData});
    },
    getMonthlyOverviewCoordinator(filterData:any) {  
        return client.get(`${serviceURL}/monthly-overview-coordinator`, {params: filterData});
    },
    getAnnualOverviewHr(filterData:any) {  
        return client.get(`${serviceURL}/annual-overview-hr`, {params: filterData});
    },
    getAnnualOverviewCoordinator(filterData:any) {  
        return client.get(`${serviceURL}/annual-overview-coordinator`, {params: filterData});
    },
    approveMonth(userId: number, year: number, month: number) {
        return client.put(`${serviceURL}/approve-month/${userId}/${year}/${month}`);
    },
    declineMonth(userId: number, year: number, month: string) {
        return client.put(`${serviceURL}/decline-month/${userId}/${year}/${month}`);
    },


    // Months for approval
    getMonthsForApproval(filterData:any ){
        return client.get(`${serviceURL}/months-for-approval`, {params: filterData});
    },
    countMonthsForApproval(){
        return client.get(`${serviceURL}/count-months-for-approval`);
    }

}